export default Object.freeze({
  CustomList: 1,
  CustomLists: 2,
  DynamicEntity: 3,
  Report: 4,
  Reports: 5,
  Process: 6,
  Processes: 7,
  Link: 8,
  SubMenu: 9,
  DynamicEntities: 10,
  EmbedHtml: 11,
  RenderTemplate: 12,
  App: 13,
  Apps: 14,
});
